export { default } from './Computer'
